import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Immutable from 'immutable';
import Content from '../../../layout/Content';
import { HOLIDAY_PATH } from '../../../../config/paths';
import {
  breadcrumbsPropTypes,
  matchPropTypes,
} from '../../../common/resource/proptypes/CommonPropTypes';
import { clearHoliday, getHoliday, putHoliday } from '../../../../actions';
import NoDataResource from '../../../common/resource/NoDataResource';
import HolidayForm from './HolidayForm';
import Loader from '../../../common/Loader';
import { tzNormalizeDate } from '../../../../utils/date';

const EditHoliday = ({
  breadcrumbs,
  match: {
    params: { id },
  },
  loading,
  holiday,
  dispatchGetHoliday,
  dispatchClearHoliday,
  dispatchPutHoliday,
}) => {
  useLayoutEffect(() => {
    dispatchGetHoliday({ holidayId: id });
    return () => dispatchClearHoliday();
  }, []);

  const onSubmit = (formValues) => {
    dispatchPutHoliday(id, formValues);
  };

  const generateInitialValues = ({ holidayDate, name, description }) => ({
    holidayDate: holidayDate
      ? tzNormalizeDate({ date: holidayDate }).slice(0, 10)
      : null,
    name,
    description,
  });

  let content;

  if (loading) content = <Loader />;
  else if (holiday.isEmpty())
    content = <NoDataResource returnPage={HOLIDAY_PATH} />;
  else {
    content = (
      <HolidayForm
        onSubmit={onSubmit}
        initialValues={generateInitialValues(holiday.toJS())}
      />
    );
  }

  return (
    <Content
      breadcrumbs={breadcrumbs}
      title="Editar Feriado"
      content={content}
    />
  );
};

EditHoliday.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  match: matchPropTypes.isRequired,
  dispatchGetHoliday: PropTypes.func.isRequired,
  dispatchClearHoliday: PropTypes.func.isRequired,
  dispatchPutHoliday: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  holiday: PropTypes.instanceOf(Immutable.Map).isRequired,
};

const mapStateToProps = (
  { HumanResourcesUnit },
  {
    match: {
      params: { id },
    },
  },
) => ({
  breadcrumbs: [
    ...HumanResourcesUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Feriados',
      href: HOLIDAY_PATH,
    },
    {
      text: 'Ver',
      href: `${HOLIDAY_PATH}/${id}`,
    },
    {
      text: 'Editar',
      href: '',
    },
  ],
  loading: !HumanResourcesUnit.Holiday.getIn(['current', 'activity']).isEmpty(),
  holiday: HumanResourcesUnit.Holiday.getIn(['current', 'content']),
});

const mapDispatchToProps = {
  dispatchGetHoliday: getHoliday,
  dispatchClearHoliday: clearHoliday,
  dispatchPutHoliday: putHoliday,
};

export default connect(mapStateToProps, mapDispatchToProps)(EditHoliday);
